import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  tableContentWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
}))
